import '@cub-com-br/theme/styles/fonts.css';
import '@cub-com-br/theme/styles/tokens.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { queryClient } from '~/api';
import { App } from './app';
import './styles.scss';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
